import React from 'react'

export default function NotFound() {
    return (
        <div>
            404, Route unknown
            <a href="/">Home page</a>
        </div>
    )
}
